import { z } from "zod"

export const powurOsModuleDataSchema = z.object({
  id: z.number().int(),
  relatedOptimizerId: z.nullable(z.number().int()),
  relatedOptimizer: z.nullable(z.any()),
  recommendedMicroinverterId: z.nullable(z.number().int()),
  recommendedMicroinverter: z.nullable(z.any()),
  openCircuitVoltage: z.nullable(z.number()).optional(),
  voltageAtMPP: z.nullable(z.number()).optional(),
  temperatureCoefficientPmpp: z.nullable(z.number()).optional(),
  temperatureCoefficientVoc: z.nullable(z.number()).optional(),
  incompatibleInverters: z.array(z.number().int()).nullable().optional(),
})
export type PowurOsModuleData = z.infer<typeof powurOsModuleDataSchema>

export type ModuleInverterCompatibilityData = Pick<
  PowurOsModuleData,
  "incompatibleInverters"
>

export const getIncompatibleInverterIds = (
  moduleData: ModuleInverterCompatibilityData | null | undefined,
): Set<number> => new Set(moduleData?.incompatibleInverters ?? [])

export const powurOsEnergyBackupDataSchema = z.object({
  id: z.number().int().optional(),
  ratedOutputPowerKilowatts: z.number().optional(),
  roundTripEfficiency: z.number().optional(),
  usableBatteryCapacityKilowatts: z.number().optional(),
  usableBatteryCapacity: z.number().optional(), // Deprecated, same reason ^^
  minimumBatteryCapacity: z.number().optional(),
  manufacturerWarrantyLengthYears: z.number().nullish(),
  loadStartCapabilityLRA: z.number().nullish(),
  // force to boolean with a default of false
  hasBackupCapability: z
    .boolean()
    .nullish()
    .transform((value) => value ?? false),
  qty: z.number().default(1),
  leadBatteryQty: z.number().int().nonnegative().nullable().optional(),
  followerBatteryQty: z.number().int().nonnegative().nullable().optional(),
})

export type PowurOsEnergyBackupData = z.infer<
  typeof powurOsEnergyBackupDataSchema
>
